module.exports = __webpack_public_path__ + "static/media/d.47927493.jpg";